import React from "react";

export const SearchIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="#18428E" />
      <path
        d="M11.75 16.5C14.3734 16.5 16.5 14.3734 16.5 11.75C16.5 9.12665 14.3734 7 11.75 7C9.12665 7 7 9.12665 7 11.75C7 14.3734 9.12665 16.5 11.75 16.5Z"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17L16 16"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
